import React from 'react';
import Icon from '../../../components/AppIcon';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PerformanceTrendsChart = ({ trends }) => {
  const chartData = trends?.map(trend => ({
    date: new Date(trend?.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    userMessages: trend?.userMessages || 0,
    agentMessages: trend?.agentMessages || 0,
    responseRate: trend?.userMessages > 0 
      ? Math.round((trend?.agentMessages / trend?.userMessages) * 100) 
      : 0
  })) || [];

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="TrendingUp" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold font-mono">Performance Trends</h2>
          <p className="text-sm text-muted-foreground">Agent activity and response patterns over time</p>
        </div>
      </div>

      {chartData?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="BarChart3" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
          <p className="text-muted-foreground">No performance data available yet</p>
        </div>
      ) : (
        <div className="w-full h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis
                dataKey="date"
                stroke="var(--color-muted-foreground)"
                style={{ fontSize: '12px' }}
              />
              <YAxis
                stroke="var(--color-muted-foreground)"
                style={{ fontSize: '12px' }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'var(--color-card)',
                  border: '1px solid var(--color-border)',
                  borderRadius: '6px'
                }}
              />
              <Legend />
              <Line
                type="monotone"
                dataKey="userMessages"
                stroke="var(--color-primary)"
                strokeWidth={2}
                name="User Messages"
                dot={{ fill: 'var(--color-primary)', r: 4 }}
              />
              <Line
                type="monotone"
                dataKey="agentMessages"
                stroke="var(--color-accent)"
                strokeWidth={2}
                name="Agent Responses"
                dot={{ fill: 'var(--color-accent)', r: 4 }}
              />
              <Line
                type="monotone"
                dataKey="responseRate"
                stroke="var(--color-success)"
                strokeWidth={2}
                strokeDasharray="5 5"
                name="Response Rate (%)"
                dot={{ fill: 'var(--color-success)', r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default PerformanceTrendsChart;